import React from 'react';
import { INavbarIconProps } from '../type';

const LogOutIcon: React.FC<INavbarIconProps> = ({ color }) => {
   return (
      <svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path
            d='M2.666 11.999h1.333v1.333h8V2.665H4V4H2.666V2c0-.368.299-.667.667-.667h9.333c.368 0 .667.299.667.667v12a.667.667 0 0 1-.667.666H3.333A.667.667 0 0 1 2.666 14zm1.333-4.667h4.667v1.333H3.999v2L.666 8l3.333-2.667z'
            fill={color}
         />
      </svg>
   );
};

export default LogOutIcon;
